export default __webpack_public_path__ + "images/3debad008db0a67b9696aa8406a9ea04-pageNotFound--light.png";